import { Component } from '@angular/core';
import { TranslatePipe } from "../../../../core/pipes/translate.pipe";

@Component({
  selector: 'app-experts-header',
  imports: [TranslatePipe],
  templateUrl: './experts-header.html',
  styleUrl: './experts-header.scss',
})
export class ExpertsHeaderComponent {}
